export const gallerySelector = (state) => state.gallery;